import { styled } from "@mui/material/styles";

const ChatWrapper = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "10px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "90%",
  },
  display: "flex",
  justifyContent: "space-between",
  gap: "10px",
  marginBottom: "50px",
  height: "100%",
}));

export { ChatWrapper };
